export enum PackageType {
  None = 0,
  Standard = 1,
  Plus = 2,
  Premium = 3,
  ALaCarte = 4,
  DealerActivator = 5,
  DealerActivatorLite = 6,
  Blueberry = 7,
  BlueberryPlus = 8,
}
